import { get, post, put } from '../services/common/common.service';
import { erpSalesOrderItemsEndPoints } from '../constants/endpoint';

//Fetch - ERP Sales Order Items
export const fetchERPSalesOrderItems = (payload) => {
  return post(erpSalesOrderItemsEndPoints.fetchERPSalesOrderItems, payload);
};

//Fetch Import Status
export const fetchImportStatus = () => {
  return get(erpSalesOrderItemsEndPoints.fetchImportStatus);
};

//Fetch Mapping Type
export const fetchMappingType = () => {
  return get(erpSalesOrderItemsEndPoints.fetchMappingType);
};

//Customer Name Contains Search Data
export const fetchCustomerNameContainsData = (payload) => {
  return post(erpSalesOrderItemsEndPoints.fetchCustomerNameContains, payload);
};

export const saveErpSalesOrderItemDisplayData = (payload) => {
  return put(erpSalesOrderItemsEndPoints.updateErpSalesOrderItemsDisplayUnsupportedFlag, payload);
};

//Modals
//Accounting Group Smart Seach - POST API to fetch the data as per payload
export const fetchAccountingGroupsData = (payload) => {
  return post(erpSalesOrderItemsEndPoints.accountingGroup, payload);
};

//Sales Product Smart Search - POST API to fetch the data as per payload
export const searchProductCodeName = (payload) => {
  return post(erpSalesOrderItemsEndPoints.SalesProducts, payload);
};

//MCN -> Accounting Group Smart Seach - POST API to fetch the data as per payload
export const fetchmcnAccountingGroupsData = (payload) => {
  return post(erpSalesOrderItemsEndPoints.mcnaccountingGroup, payload);
};

export const fetchCustomerSearch = (payload) => {
  return post(erpSalesOrderItemsEndPoints.customerSearch, payload);
};

export const mcncustomerNameSmartSearchData = (payload) => {
  return post(erpSalesOrderItemsEndPoints.customerSearchByName, payload);
};

export const fetchmcnAccountingGroups = (payload) => {
  return post(erpSalesOrderItemsEndPoints.mcnaccountingGroup, payload);
};

export const orderGroupSmartSearchData = () => {
  return get(erpSalesOrderItemsEndPoints.orderGroups);
};

export const getErpSalesItemsEntitlements = (payload) => {
  return post(erpSalesOrderItemsEndPoints.erpSalesOrderItemEntitlements, payload);
};

export const createEntitlement = (payload) => {
  return post(erpSalesOrderItemsEndPoints.createEntitlement, payload);
};

export const jobCreateEntitlements = () => {
  return get(erpSalesOrderItemsEndPoints.jobCreateEntitlements);
};

export const resetLine = (payload) => {
  return post(erpSalesOrderItemsEndPoints.resetLine, payload);
};